import type { CSMColourTheme } from '../../types';
import { generateColorRamps } from './color-ramps-generator';
import { isValidHex } from './hex';

/**
 * Default primary color for CSM branding
 */
const CSM_BRANDING_DEFAULT_PRIMARY_COLOR = '#B5B5B5';

export const generateThemeBranding = (primaryColour: string): CSMColourTheme =>
	generateColorRamps(
		isValidHex(primaryColour) ? primaryColour : CSM_BRANDING_DEFAULT_PRIMARY_COLOR,
	);
